import script from "./GlobalAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalAlert.vue?vue&type=script&setup=true&lang=js"

import "./GlobalAlert.vue?vue&type=style&index=0&id=013d228c&lang=scss"

const __exports__ = script;

export default __exports__